import { useStaticQuery, graphql } from "gatsby"

const useLatestCaseStudiesQuery = () => {
  return useStaticQuery(graphql`
    query LatestCaseStudiesQuery {
      allWpCaseStudy(
        sort: {date: DESC}
      ) {
        nodes {
          id
          title
          uri
          acf {
            propertyImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1000
                  )
                }
              }
            }
            agents {
              ... on WpTeam {
                title
              }
            }
          }
        }
      }
    }
  `)
}

export default useLatestCaseStudiesQuery